import type React from "react";
import type { JSX } from "react";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: JSX.Element;
  theme?: "light" | "dark";
  maxWidth?: string; // Add this prop for custom width
  noPadding?: boolean;
};

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  theme = "light",
  maxWidth = "max-w-md", // Set a default value
  noPadding = false,
}) => {
  if (!isOpen) return null;

  const themeStyles = {
    light: {
      bg: "bg-white",
      closeButton: "text-gray-400 hover:text-gray-700",
    },
    dark: {
      bg: "bg-gray-800",
      closeButton: "text-gray-400 hover:text-white",
    },
  };
  const currentTheme = themeStyles[theme];

  const handleBackdropMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    // เช็คว่าตำแหน่งที่กดเมาส์ลงไป คือตัวพื้นหลังสีดำจริงๆ (currentTarget)
    // ไม่ใช่การกดที่เกิดจาก Element ลูกข้างในแล้วลากออกมา (target)
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      <style>{`
        @keyframes fade-in-scale {
          0% { opacity: 0; transform: scale(0.95); }
          100% { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in-scale {
          animation: fade-in-scale 0.2s ease-out forwards;
        }
      `}</style>
      <div
        // 💡 2. เปลี่ยนจาก onClick={onClose} เป็น onMouseDown
        onMouseDown={handleBackdropMouseDown}
        className="fixed inset-0 z-50 flex items-center justify-center bg-[oklch(0_0_0/0.3)] backdrop-blur-sm p-4"
      >
        <div
          // 💡 แก้ไข: เอา p-6 แบบตายตัวออก และเพิ่ม flex flex-col overflow-y-auto
          className={`relative p-6 w-full rounded-xl shadow-xl animate-fade-in-scale flex flex-col overflow-y-auto ${currentTheme.bg} ${maxWidth} max-h-[90vh] ${noPadding ? "p-0" : "p-6 md:p-8"}`}
        >
          {children}
        </div>
      </div>
    </>
  );
};
